import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-32 relative z-10 overflow-hidden bg-hubble-card/30" data-id="element-19">
      {/* Background glow for CTA */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-hubble-signal/5 blur-[100px] rounded-full pointer-events-none" data-id="element-20"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-22">
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-paper mb-6" data-id="element-23">
            Ready to ship agents using reliable & integrated healthcare infra?
          </h2>

          <Button variant="primary" size="lg" onClick={() => window.open('https://calendly.com/prabha-hubble/30min?month=2026-04', '_blank')} data-id="element-24">
            Book Demo
          </Button>
        </motion.div>
      </div>
    </section>;
}